export default __webpack_public_path__ + "assets/Lato-Light.c7400fcad9e48ca9043f49d9a5f389dc.ttf";